import React, { useState } from "react";
import "./CSS/PrivacyPolicy.css";
import { FaEnvelope, FaPhoneAlt } from "react-icons/fa";
import { Link } from "react-router-dom";

import { FaInstagram, FaTwitter, FaLinkedin } from 'react-icons/fa';


const Terms = ({ onContactClick }) => {
      const [menuOpen, setMenuOpen] = useState(false);
    
      const toggleMenu = () => {
        setMenuOpen(!menuOpen);
      };
  return (
   <div className="privacy-container">
            <header className="home-header">
           <div className="logo">
             <img
               alt="Designvio.pvt.Ltd"
               className="logo-icon"
               src="../Images/DLogo.png"
             />
           </div>
   
           <div className="hamburger" onClick={toggleMenu}>
             <div className="bar"></div>
             <div className="bar"></div>
             <div className="bar"></div>
           </div>
   
           <nav className={`nav-links ${menuOpen ? "open" : ""}`}>
             <a href="#about">ABOUT</a>
             <a href="#services">SERVICES</a>
             <a href="#work">WORK</a>
             <a href="#contact" onClick={onContactClick}>
               CONTACT
             </a>
           </nav>
         </header>
         <div className="privacy-header">
           <h1>Terms and Conditions</h1>
          <p className="breadcrumb">
              <Link to="/" className="breadcrumb-link">Home</Link> / 
              <span className="active">Terms and Conditions</span>
            </p>
         </div>
   
         <div className="privacy-content">
           <h1>
            By using our website, you agree to the following terms</h1>
   
           <h2>Orders:</h2>
           <ul>
             <li>All orders are subject to product availability and confirmation.</li>
             <li>Prices listed include applicable taxes unless mentioned otherwise.</li>
           </ul>
   
           <h2>Payments:</h2>
           <ul>
             <li>We accept secure online payments via integrated payment gateways.</li>
             <li>Orders will be processed once payment is confirmed.</li>
           </ul>
           <h2>Product Information:</h2>
            <ul>
         <li>We make every effort to display accurate product details, dimensions, and colors.Actual product colors may slightly vary due to lighting and screen differences.</li>
</ul>
           <h2>Use of Website:</h2>
           <p>
            You agree not to misuse the website or engage in unlawful activities.
           </p>
   
           <div className="contact-section">
             <p>For support, contact:</p>
             <div className="contact-info">
               <FaEnvelope className="icon" />
               <a href="mailto:craftsmize.com@gmail.com">
                 designvioux@gmail.com
               </a>
               {/* <span>/</span>
               <a href="mailto:info@craftsmize.com">info@craftsmize.com</a> */}
               <FaPhoneAlt className="icon phone" />
               <a href="tel:878897094">7875010115</a>
             </div>
           </div>
             </div>
            <footer className="footer" id='contact'>
                 <div className="footer-top">
                   <div className="footer-left">
                     <img src="../Images/DLogo.png" alt="Designvio Logo" className="footer-logo" />
                     {/* <h2>DESIGNVIO<br />(OPC) PVT LTD</h2> */}
            <div className="footer-address">
               <h3>Address</h3>
               <p>Branch 1: Designvio 523/B Karanje Peth, Satara.</p>
               <p>Branch 2: Designvio AssemblyRd, New Shahupuri, Kolhapur.</p>
             </div>
                     <nav className="footer-page">
                                {/* <a className='link-c' href="#about">ABOUT-US</a> */}
                              <Link className='link-c' to="/privacy-policy">Privacy Policy</Link>
                              <Link className='link-c' to="/terms-conditons">Terms And Conditions</Link>
                              <Link className='link-c' to="/cancellation">Cancellation And Refunf Policy</Link>
                              <Link className='link-c' to="/shipping">Shipping And Delivery Policy</Link>
                                {/* <a className='link-c'  href="#team">TEAM</a> */}
                                {/* <a className='link-c' href="#services">SERVICES</a>
                                <a className='link-c' href="#work">PORTFOLIO</a>
                                <a className='link-c' href="#faqs">FAQ-S</a>
                                <a className='link-c' href="#process">THE PROCESS</a> */}
                              </nav>
                    
                   </div>
           
                   <div className="footer-right">
                     <div className="footer-box">
                       <h3 className='touch'>GET IN TOUCH</h3>
                       <p className='tel-link'>Tel: <a className='tel-link' href="tel:‪+917058035999‬">‪+91 7058035999‬</a> / <a className='tel-link' href="tel:‪+917875010115‬">‪+91 7875010115‬</a></p>
                       <hr />
                       <h3 className='follow'>FOLLOW US</h3>
                       <div className="social-icons">
                         <a className='social-link' href="https://instagram.com" target="_blank" rel="noreferrer"><FaInstagram /></a>
                         <a className='social-link' href="https://twitter.com" target="_blank" rel="noreferrer"><FaTwitter /></a>
                         <a className='social-link' href="https://linkedin.com" target="_blank" rel="noreferrer"><FaLinkedin /></a>
                       </div>
                     </div>
                   </div>
           
                 </div>
           
                 
                 <div className="footer-bottom">
                   <p>© 2024 Copyright <strong className='cp'>Designvio</strong></p>
                  
                 </div>
          
               </footer>
        
       </div>
     );
};

export default Terms;
